import { render, staticRenderFns } from "./FinancialAdjustmentDetailsSidebar.vue?vue&type=template&id=0bf171c6"
import script from "./FinancialAdjustmentDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./FinancialAdjustmentDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./FinancialAdjustmentDetailsSidebar.vue?vue&type=style&index=0&id=0bf171c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports